import { render, staticRenderFns } from "./GoldenFollowerTip.vue?vue&type=template&id=4d195f13&scoped=true&"
import script from "./GoldenFollowerTip.vue?vue&type=script&lang=ts&"
export * from "./GoldenFollowerTip.vue?vue&type=script&lang=ts&"
import style0 from "./GoldenFollowerTip.vue?vue&type=style&index=0&id=4d195f13&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d195f13",
  null
  
)

export default component.exports